import { render, staticRenderFns } from "./EmployeeSalarySlip.vue?vue&type=template&id=d0bd282c&scoped=true"
import script from "./EmployeeSalarySlip.vue?vue&type=script&lang=js"
export * from "./EmployeeSalarySlip.vue?vue&type=script&lang=js"
import style0 from "./EmployeeSalarySlip.vue?vue&type=style&index=0&id=d0bd282c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0bd282c",
  null
  
)

export default component.exports